import { render } from "./AddEditCategory.vue?vue&type=template&id=5437d7e8&scoped=true"
import script from "./AddEditCategory.vue?vue&type=script&lang=js"
export * from "./AddEditCategory.vue?vue&type=script&lang=js"

import "./AddEditCategory.vue?vue&type=style&index=0&id=5437d7e8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5437d7e8"]])

export default __exports__